/** Audit surface shared helpers. Ported from prototype stage-audit.jsx. */
import { fmtEur } from "../../lib/format";
import type { DiscrepancyStatus, DiscrepancyType } from "../../lib/tenderApi";

export { fmtEur };

export type ResolutionStatus = "Risolto" | "In revisione" | "Non risolto";

const DISCREPANCY_LABEL: Record<DiscrepancyType, string> = {
  qty_mismatch: "Quantità divergente",
  price_mismatch: "Prezzo fuori range",
  desc_mismatch: "Descrizione divergente",
  // `P-75` — NOT «prezzo fuori range». The book publishes no price for this
  // code, so there is no range and no comparison; saying anything about the
  // contractor's figure here would be an accusation the data cannot support.
  price_unavailable: "Confronto non possibile",
  // `P-73` — a claim about the tender document's own arithmetic, not about the
  // price book. Named for what it is so a reader does not go looking for a
  // listino that has nothing to do with it.
  total_mismatch: "Totale non coerente",
};

export function discrepancyTypeLabel(t: DiscrepancyType): string {
  // `Record` + a fallback, not a bare index. An index signature returns
  // `undefined` for an unknown value and React renders that as nothing — so a
  // finding from a newer server than this bundle would appear as a blank chip
  // rather than as itself. A visible, honest word beats an invisible row.
  return DISCREPANCY_LABEL[t] ?? "Verifica";
}

/** Backend has 4 discrepancy states; the UI has 3 buttons. `open` and
 * `unresolved` both read as "Non risolto"; the write maps "Non risolto" →
 * `unresolved` (the explicit not-resolved state). */
export function statusFromBackend(s: DiscrepancyStatus): ResolutionStatus {
  if (s === "resolved") return "Risolto";
  if (s === "in_review") return "In revisione";
  return "Non risolto"; // open | unresolved
}

export function statusToBackend(s: ResolutionStatus): DiscrepancyStatus {
  if (s === "Risolto") return "resolved";
  if (s === "In revisione") return "in_review";
  return "unresolved";
}

export function statusBg(s: ResolutionStatus): string {
  return {
    Risolto: "var(--c-ok-soft)",
    "In revisione": "var(--c-info-soft)",
    "Non risolto": "var(--c-err-soft)",
  }[s];
}

export function statusFg(s: ResolutionStatus): string {
  return { Risolto: "var(--c-ok)", "In revisione": "var(--c-info)", "Non risolto": "var(--c-err)" }[
    s
  ];
}

export interface Comment {
  text: string;
  ai: boolean;
  time: string;
  author: string;
}
